import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/opt/buildhome/repo/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/opt/buildhome/repo/markdoc/tags.js'
import * as nodes from '/opt/buildhome/repo/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Overview of the components\ndescription: Mendable Components\n---\n\nMendable has 4 main components:\n\n- [Mendable Search Bar](/components/search-bar)\n- [Mendable InPlace Component](/components/in-place)\n- [Mendable Floating Button](/components/floating-button)\n- [Mendable Chat Bubble](/components/chat-bubble)\n\n\n\n## Mendable Search Bar\n\nThe search bar is a component similar to an search bar input. When the user clicks the search bar, it will open a modal with Mendable Search. \n\n![](/images/search-bar.png)\n\n## Mendable Floating Button\n\nThe floating button is a fixed button to the bottom right of the screen that will open a modal with Mendable Search.\n\n![](/images/floating-button.png)\n\n## Mendable InPlace Component\n\nThis component is the Mendable Chat only, does not include an activation component or dialog transitions, making it easy for you to create your own activations on top of it. Soon to be released in the docs.\n\n![](/images/inplace.png)\n\n## Mendable Chat Bubble\n\nThe chat bubble is a fixed button to the bottom right of the screen that will open a modal with Mendable Search. It is similar to the floating button, but it is a small bubble that will expand when the user clicks on it.\n\n![](/images/chat-bubble.png)\n\n\n## Custom Components\n\nYou can use our backbone architecture to build your own Mendable Search component. You can find the documentation [here](/mendable-api/overview).\n";
const filepath = "/components/overview.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
